export const cancelButton = "dIa";
export default {cancelButton};